import FormFieldMixins from '../form-field-mixin';

export default {
  name: 'FormInput',
  mixins: [FormFieldMixins],
  props: {
    inputType: {
      type: String,
      default: 'text',
    },
    renderSlot: {
      type: [Array, Boolean],
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: null,
    },
    notice: {
      type: String,
      default: null,
    },
    datalist: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFilePath: '',
    };
  },
  created() {
    this.$bus.on('remove-file-item', this.onRemoveFileItem);
  },
  computed: {
  },
  beforeDestroy() {
    this.$bus.off('remove-file-item', this.onRemoveFileItem);
  },
  render(h) {
    if (!this.isDisplay) {
      return h();
    }
    if (this.inputType === 'hidden') {
      return h(
        'div', {},
        [this.renderField(h), (this.validation || this.asyncValidation) ? this.renderErrorText(h) : null],
      );
    }
    return this.renderFormGroup(h);
  },
  methods: {
    onRemoveFileItem(index) {
      if (!this.localValue && !this.localValue.length) return;
      const dt = new DataTransfer();
      const files = this.localValue;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (index !== i) { dt.items.add(file); } // here you exclude the file. thus removing it.
      }
      if (dt.files.length) {
        this.localValue = dt.files;
      } else {
        this.localFilePath = '';
        this.localValue = null;
      }
      this.isChanged = this.initialValue !== this.localValue;
      this.$emit('input', {}, { name: this.name, value: this.localValue });
    },
    onInput($event) {
      if (this.inputType === 'file') {
        this.localFilePath = $event.target.value;
        if ($event.target.files.length > 0 || !!$event.dataTransfer.files.length) {
          this.localValue = this.multiple ? $event.target.files : $event.target.files[0];
        } else {
          this.localValue = null;
        }
      } else {
        this.localValue = $event.target.value;
      }
      this.isDirty = true;
      this.isChanged = this.initialValue !== this.localValue;
      this.$emit('input', $event, { name: this.name, value: this.localValue });
    },
    renderField(h) {
      const inputDirectives = [];
      if (this.validation) {
        inputDirectives.push({
          name: 'validate',
          value: this.validation,
          expression: 'validation',
        });
      }
      const valueProps = this.inputType === 'file' ? this.localFilePath : this.localValue;
      const attrs = {
        id: this.name,
        type: this.inputType,
        name: this.name,
        placeholder: this.$t(this.placeholder),
        disabled: typeof this.disabled === 'function' ? this.disabled() : this.disabled,
        readonly: this.readonly,
        notice: this.notice,
        list: this.datalist || undefined,
        'data-vv-as': this.label,
      };
      if (this.inputType === 'file' && this.multiple) {
        attrs.multiple = true;
        attrs.accept = this.accept;
      }

      return h('input', {
        domProps: { value: valueProps },
        attrs,
        class: {
          'form-control': !this.readonly,
          'is-invalid': this.isInvalid,
          'form-control-plaintext': this.readonly,
          'drag-and-drop': this.draggable,
          'form-custom-fill': this.variant === 'fill',
        },
        on: {
          input: this.onInput,
          ...(this.draggable && {
            dragover: (event) => {
              event.stopPropagation();
              event.preventDefault();
            },
            drop: this.onInput,
          }),
        },
        directives: inputDirectives,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app-form/fields/form-input.js